import { useQuery } from "@tanstack/react-query";
import queryKey from "../enumerations/queryKey";
import { getUserCurrency } from "../plugins/utils";
import { getSetting } from "./service";

const userCurrency = getUserCurrency();

export const useGetRebateMode = ({ options }) => {
  return useQuery(
    [queryKey.REBATE_MODE],
    () =>
      getSetting({ userCurrency: userCurrency }).then((res) => {
        const data = res.data.data;
        if (data && data?.length > 0) {
          const rebateModeSetting = data.find((_data) => _data.code === "agent_rebate_mode");
          if (rebateModeSetting) {
            return rebateModeSetting.value;
          }
        } else {
          return null;
        }
      }),
    {
      ...options,
    },
  );
};
